import { isNil } from "lodash";
import type { RocketchatResponseHandler } from "../RocketchatResponseHandler";
import type { ChatMessage } from "../chatMessage/chatMessage.entity";
import { chatMessageGroupByChannelIdSelectors } from "../chatMessage/chatMessageSlice";
import { store } from "../redux/store";
import { readMessageEventThunk } from "./chatEventThunk";
import { retrieveTargetsForReadUpdate } from "./retrieveTargetsForReadUpdate";

export const handleReadMessageEventHandler: RocketchatResponseHandler = ({
  response,
}) => {
  const readMessage = response?.read_message;

  if (isNil(readMessage)) {
    throw new Error("readMessageEventHandler: readMessage is nil");
  }

  const messages = chatMessageGroupByChannelIdSelectors(
    store.getState().chatMessage,
  )[readMessage.channel_id];

  if (isNil(messages)) {
    throw new Error("readMessageEventHandler: messages is nil");
  }

  const isContainsReadMessage = messages.some(
    (message) => message.id === readMessage.message_id,
  );
  const readerId = readMessage.reader?.id;

  if (!isContainsReadMessage || isNil(readerId)) {
    return;
  }

  const updateTargets: ChatMessage[] = retrieveTargetsForReadUpdate({
    messages,
    readerId,
    readMessageId: readMessage.message_id,
  });

  store.dispatch(
    readMessageEventThunk({
      chatMessages: updateTargets,
    }),
  );
};
